export function LayoutWrapper({ children, id, maxWidth = false }: { children: React.ReactNode }) {
  return (
    <div
      id={id}
      className={`${maxWidth ? "w-full" : "main-width"}
        max-w-[1280px] 
        2xl:max-w-[1400px] 
        mx-auto
      `}
    >
      {children}
    </div>
  )
}
